import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Button } from '@gsa/afp-component-library';

const DuplicateUpiidRenewalAlert = ({ solicitationObj }) => {
  const navigate = useNavigate();

  return (
    <>
      <h3 className="usa-alert__heading margin-right-2">Error status</h3>

      <p className="margin-bottom-0">
        There is already a solicitation with the entered uPIID in the system and
        is eligible for renewal.
      </p>
      <p className="margin-top-0 margin-bottom-1">
        Select Renew to renew the{' '}
        <b> Solicitation {solicitationObj.solicitationNumber} </b> or create a
        new solicitation using a unique uPIID number.
      </p>

      <Button
        data-testid="solicitation-renew-btn"
        type="button"
        className="margin-top-2 margin-bottom-2"
        onClick={() => {
          navigate(`/catalog/solicitations/renew/${solicitationObj.id}`);
        }}
        label="Renew"
      />
    </>
  );
};

DuplicateUpiidRenewalAlert.propTypes = {
  solicitationObj: PropTypes.shape({
    id: PropTypes.number,
    solicitationNumber: PropTypes.string,
  }).isRequired,
};

export default DuplicateUpiidRenewalAlert;
